import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-cookie-policy-banner',
  templateUrl: './cookie-policy-banner.component.html',
  styleUrls: ['./cookie-policy-banner.component.scss']
})
export class CookiePolicyBannerComponent implements OnInit {

 
  cookiesAccepted: boolean = false;

  ngOnInit(): void {
    // Check if the user has already accepted cookies
    this.cookiesAccepted = localStorage.getItem('cookiesAcceptedForBusinessWeb') === 'true';
  }

  closeBanner(): void {
    // Close the banner
    // document.querySelector('.cookie-banner')?.classList.add('closed');
    this.cookiesAccepted = true
  }

  acceptCookies(): void {
    // Set a localStorage item to remember that cookies have been accepted
    localStorage.setItem('cookiesAcceptedForBusinessWeb', 'true');
    this.cookiesAccepted = true;

    // Close the banner
    this.closeBanner();
  }
}
